module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"btn-copy-to-clipboard-msg-success":"FAQ Link für: <b>{gotcha}</b> wurde erfolgreich generiert"},"fr":{"btn-copy-to-clipboard-msg-success":"Lien FAQ pour: <b>{gotcha}</b> a été généré avec succès"},"it":{"btn-copy-to-clipboard-msg-success":"FAQ Link per: <b>{gotcha}</b> è stato generato con successo"}}')
  delete Component.options._Ctor
}
